import { html, nothing, TemplateResult } from 'lit-html';
import CloseButtonTemplate from '@libs/modal/closeButton';
import { ErrorModalTemplate, WelcomeModalTemplate } from '@components/commonTemplate';
import FormTemplate from '../favouriteModalForm';
import MySearchesTemplate from '../mySearches';

const ModalProposalTemplate = async (config: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {
  const {
    messages,
    feature: {
      confirmationSingleClickEnabled
    }
  } = config;
  const {
    close,
    modalState,
    socialSubscriptionError,
    linkToInboxProviderUrl,
    formData
  } = model;

  const welcomeTemplateProps: IWelcomeModalTemplateProps = {
    messages,
    close,
    linkToInboxProviderUrl,
    email: formData.email?.value,
    source: confirmationSingleClickEnabled ? 'welcome' : 'confirmation_reminder'
  };

  return html`
    <div class="js-modal-skeleton">
      <div class="proposal">
        ${CloseButtonTemplate(close)}
        ${modalState === 'error' ? ErrorModalTemplate({ messages, close, socialSubscriptionError }) : nothing}
        ${modalState === 'proposal' ? await FormTemplate(config, model) : nothing}
        ${modalState === 'mySearches' ? await MySearchesTemplate(config, model) : nothing}
        ${modalState === 'welcome' ? WelcomeModalTemplate(welcomeTemplateProps) : nothing}
      </div>
    </div>`;
}

export default ModalProposalTemplate;
